import { API_ENDPOINT } from "../constants";
import { Component } from "react";
import { Player } from '@lottiefiles/react-lottie-player';

export default class SsoLoginPage extends Component {
	constructor(props) {
		super(props);

		this.state = {};
	};

	abort = (to = '/login') => {
		this.props?.[0]?.history?.replace?.(to);
	}

	handleSsoLogin = async (sso_token) => {
		const bearerToken = typeof window !== 'undefined' && localStorage ? localStorage.getItem('authToken') : null;

		const response = await fetch(`${API_ENDPOINT}/sso/token`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': bearerToken ? `Bearer ${bearerToken}` : undefined,
			},
			body: JSON.stringify({ sso_token })
		});

		if (!response.ok) return this.abort();

		const result = await response.json();
		if (!result || !result.navigateTo || typeof result.navigateTo !== 'string' || !result.clinicGroupId || !result.groupAlias) return this.abort();

		try {
			localStorage.setItem('userLevel', 20);
			localStorage.setItem('logoutLandingPage', true);
			localStorage.setItem("profile", "doctor");
			localStorage.setItem("time", Math.floor(Date.now() / 1000));
			localStorage.removeItem('groupAlias');
		} catch (err) { }

		if (result.token) {
			// Full login - full flow
			try {
				if (result?.userData && typeof window !== 'undefined') {
					localStorage?.setItem?.('userData', JSON.stringify(result?.userData));
				}
			} catch (err) {
				console.error('login user data err: ', err);
			}

			localStorage.setItem("authToken", result.token);
			this.props.registerLog?.("Logged in");

			this.props.verifyUser?.(
				() => {
					this.props.registerClinicGroupLogs?.({
						type: 'login',
						loginType: 'sso',
					});
					if (typeof window !== 'undefined' && localStorage) {
						localStorage?.setItem?.('groupAlias', result.groupAlias)
					}
				},
				() => {
					this.props.changeGroup?.(result.clinicGroupId);
				},
				undefined,
				() => {
					this.props[0].history.replace(result.navigateTo);
				}
			)
		} else {
			// Already logged in - just switch group + navigate
			this.props.verifyUser?.(
				() => {
					this.props.changeGroup?.(result.clinicGroupId);
					this.props[0].history.replace(result.navigateTo);
				}
			)
		}
	}

	componentDidMount() {
		const sso_token = this.props?.[0]?.match?.params?.ssoToken;
		if (!sso_token) return this.abort();

		this.handleSsoLogin(sso_token);
	}

	render() {
		return <div style={{ width: '100%', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
			<Player
				autoplay={true}
				loop={true}
				src="/lf30_editor_l5cxzdyf.json"
				style={{ height: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px", width: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px" }}
			></Player>

		</div>
	}
}